import { Checkbox, Divider, ListItem, Typography } from '@mui/material';
import React, { useContext } from 'react';
import OrdersContext from '../../Context/Orders/OrdersContext';

export default function OrderListItem({ orderId, item, items }) {
	const { onChangeCheckedItem } = useContext(OrdersContext);
	return (
		<>
			<ListItem>
				<Checkbox
					size='small'
					edge='start'
					checked={item.checked}
					disableRipple
					onChange={(e) =>
						onChangeCheckedItem(orderId, e.target.checked, item, items)
					}
					inputProps={{ 'aria-labelledby': item.label }}
				/>
				<Typography>
					{item.value} {item.label}
				</Typography>
			</ListItem>
			<Divider />
		</>
	);
}
